import "./AboutPage.css";
//import '../MethodologyPage/MethodologyPage.css'

/**
 * About page component reproducing iscri_about.html content
 * Displays information about SKEMA Business School and ISCRI development
 */
const AboutPage = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="hero-about">
        <div className="container hero-about-content">
          <h1 className="page-title">About ISCRI</h1>
        </div>
      </section>

      {/* About Content Section */}
      <section className="about-content">
        <div className="container">
          <div className="creative-layout">
            {/* SKEMA Business School Section */}
            <div className="content-block skema-block reveal-element">
              <div className="icon-container">
                <div className="icon">🌍</div>
              </div>
              <div className="block-content">
                <h2 className="block-title">SKEMA Business School</h2>
                <p className="block-text">
                  SKEMA Business School is a global school that prepares the
                  business talents of the 21st century -
                  <span className="highlight-text"> responsible</span>,
                  <span className="highlight-text"> mobile</span>,
                  <span className="highlight-text"> multicultural</span>,
                  entrepreneurs with abilities to manage information, data and
                  knowledge.
                </p>
              </div>
            </div>

            {/* ISCRI Development Section */}
            <div className="content-block development-block reveal-element">
              <div className="icon-container">
                <div className="icon">🤝</div>
              </div>
              <div className="block-content">
                <h2 className="block-title">ISCRI Development</h2>
                <p className="block-text">
                  The ISCRI has been developed by{" "}
                  <strong>SKEMA Centre for Global Risks</strong>, in partnership
                  with:
                </p>
                <ul className="partnership-list">
                  <li>SKEMA School of Geopolitics for Business</li>
                  <li>SKEMA Artificial Intelligence Innovation Centre</li>
                  <li>SKEMA Publika</li>
                </ul>
              </div>
            </div>

            {/* Research Excellence Section */}
            <div className="content-block research-block reveal-element">
              <div className="icon-container">
                <div className="icon">🔬</div>
              </div>
              <div className="block-content">
                <h2 className="block-title">Research Excellence</h2>
                <p className="block-text">
                  SKEMA's commitment to research excellence drives the
                  development of innovative tools like ISCRI, which bridge
                  academic rigor with practical applications for business and
                  policy-making in an increasingly interconnected world.
                </p>
              </div>
            </div>

            {/* Global Impact Section */}
            <div className="content-block impact-block reveal-element">
              <div className="icon-container">
                <div className="icon">📊</div>
              </div>
              <div className="block-content">
                <h2 className="block-title">Global Impact</h2>
                <p className="block-text">
                  By providing real-time insights into interstate conflictual
                  relations, ISCRI serves stakeholders worldwide in
                  understanding geopolitical tensions that can influence trade
                  flows, capital movements, and global economic stability.
                </p>
              </div>
            </div>

            {/* Contact Section */}
            <div className="content-block contact-block reveal-element">
              <div className="icon-container">
                <div className="icon">✉️</div>
              </div>
              <div className="block-content">
                <h2 className="block-title">Contact & Feedback</h2>
                <p className="block-text">
                  Please send an email to <strong>Rodolphe Desbordes</strong>{" "}
                  for further information, comments, and feedback.
                </p>
                <div className="contact-info">
                  <a
                    href="mailto:rodolphe.desbordes@skema.edu"
                    className="contact-email"
                  >
                    rodolphe.desbordes@skema.edu
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;